export const loadUserState = () => {
  const defaultState = {
    users: [],
    loggedUser: {},
  };
  try {
    const serializedState = localStorage.getItem("user");
    if (!serializedState && serializedState === null) {
      return defaultState;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return defaultState;
  }
};

export const loadQuestionState = () => {
  const defaultState = {
    allQuestions: [],
  };
  try {
    const serializedState = localStorage.getItem("question");

    if (!serializedState || serializedState === null) {
      return defaultState;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return defaultState;
  }
};

export const saveState = (state:any) => {
  saveUserState(state);
  saveQuestionState(state);
};

const saveUserState = (state:any) => {
  try {
    const serializedState = JSON.stringify(state.userReducer);
    localStorage.setItem("user", serializedState);
  } catch (err) {
    // TODO
  }
};

const saveQuestionState = (state:any) => {
  try {
    const serializedState = JSON.stringify(state.questionReducer);
    localStorage.setItem("question", serializedState);
  } catch (err) {
    // TODO
  }
};

export const restState = () => {
  try {
    const defaultUserState = {
      users: [],
      loggedUser: {},
    };
    const defaulQuestiontState = {
      allQuestions: [],
    };
    saveUserState(defaultUserState);
    saveQuestionState(defaulQuestiontState);
  } catch (error) {
    // TODO
  }
};
